import React from 'react';

import {ModalPopup} from '@kit';

import {useCharacter} from '../character-context';
import {GlossaryDescription} from './expandable-row';
import {formatBonus} from './format';

import css from './sheet.module.css';

type Props = {
	onClose(): void;
};

/** из чего складывается текущий КБ и статья «Класс брони» */
export const ArmorClassModal: React.FC<Props> = ({onClose}) => {
	const {character} = useCharacter();
	const [base, ...bonuses] = character.armorClassParts;

	return (
		<ModalPopup open onClose={onClose} header="Класс брони" maxWidth={560}>
			<table className={css.armorClassTable}>
				<tbody>
					{base && (
						<tr>
							<td>{base.title}</td>
							<td className={css.armorClassValue}>{base.value}</td>
						</tr>
					)}
					{bonuses.map(({title, value}, index) => (
						<tr key={`${title}-${index}`}>
							<td>{title}</td>
							<td className={css.armorClassValue}>{formatBonus(value)}</td>
						</tr>
					))}
				</tbody>
				<tfoot>
					<tr>
						<th scope="row">Итого</th>
						<td className={css.armorClassValue}>{character.armorClass}</td>
					</tr>
				</tfoot>
			</table>
			<GlossaryDescription id="ac" className={css.restArticle} />
		</ModalPopup>
	);
};
